import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux"; // Add Redux hooks
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select"
import Swal from "sweetalert2";
import { Line } from "react-chartjs-2";
import "react-tooltip/dist/react-tooltip.css";
import { useLocation } from "react-router-dom";
import { Tab, Nav, Button, Modal } from "react-bootstrap";
import "chart.js/auto";
import icon3 from "../../../../src/assets/images/medical-report.png"
import sendreport from "../../../../src/assets/images/send-file.png"
import Prescription from "../AppsMenu/Patients/Components/ServiceCallerPrescription.Component";
import DiseaseHistory from "../AppsMenu/Patients/Components/DiseaseHistory";
import ServiceCallerFollowup from "../AppsMenu/Patients/Components/ServiceCallerFollowUp.Component";
import ServiceCallerNotes from "../AppsMenu/Patients/Components/ServiceCalllerNotes.Component";
import ServiceCallerFollowupReminder from "../AppsMenu/Patients/Components/ServiceCallerFollowupreminder.Component";
import { getPatientDetailsAction } from "../../../store/actions/ServiceCallerPrescriptionAction"; // Add your action import
import { ServiceCallerAppointmentCalendar } from "../Common/CommonAppointmentCalendar.example";
import WeightChart from "../AppsMenu/Patients/Components/WeightChart";
import { getDiseaseWiseScript } from "../../../services/ScriptService";
import { getDiseasesAction } from "../../../store/actions/DiseasesAction";
//Images
import defaultAvatar from "../../../../src/assets/images/avatar/patient_profile.png";
import icon from "../../../../src/assets/images/icons8-chart-48.png";
import emergencyIcon from "../../../../src/assets/images/emergancy.png"
import EmergencyModal from "./EmergencyModal";
import MenopauseChart from "../AppsMenu/Patients/Components/PatientMenopause.Component"
import PatientGapld from "../AppsMenu/Patients/Components/PateintGapldServiceComponent"
import PatientMale from "../AppsMenu/Patients//Components/PatientMalechart.Component"
import { formatName } from "../../../utils/formatName";
import UploadReportButton from "../Common/UploadReportButton";
import { NotesHistory } from "../AppsMenu/Patients/Components/NotesHistory";
import axiosInstance from "../../../services/AxiosInstance";
import { updatePanchkarmaTakenAction } from "../../../store/actions/ServiceCallerAction";
import { sendReportLinkAction } from "../../../store/actions/ReportAction";
const initialEvents = [
  {
    title: "Booked",
    start: new Date("2025-02-15 10:00:00"),
    end: new Date("2025-02-15 11:00:00"),
    classNames: ["bg-red"],
  },
  {
    title: "Booked",
    start: new Date("2025-02-18 11:00:00"),
    end: new Date("2025-02-18 12:00:00"),
    classNames: ["bg-red"],
  },
  {
    title: "Booked",
    start: new Date("2025-01-20 12:00:00"),
    end: new Date("2025-01-20 13:00:00"),
    classNames: ["bg-red"],
  },
];
const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  if (isNaN(date)) return "-";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

// LineChart1 component
const LineChart1 = ({ weightData }) => {
  const data = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
    datasets: [
      {
        label: "Weight Data",
        data: weightData,
        borderColor: "rgba(54,201,95,1)",
        borderWidth: 2,
        backgroundColor: "rgba(54,201,95, 0)",
        tension: 0.4,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        min: 0,
        max: 100,
        ticks: {
          beginAtZero: true,
        },
      },
      x: {
        ticks: {
          padding: 5,
        },
        grid: {
          display: false,
        },
      },
    },
  };

  return <Line data={data} options={options} height={150} />;
};

const ViewDetails = () => {
  const location = useLocation();
  const { patientId, patientName, patientGender } = location.state || {};
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Redux state
  const patientDetails = useSelector(
    (state) => state.prescriptionState?.patientDetails
  );
  const [showEmergencyModal, setShowEmergencyModal] = useState(false);
  const [emergencyPatient, setEmergencyPatient] = useState(null);
  const openEmergencyPopup = (patient) => {
    setEmergencyPatient(patient);
    setShowEmergencyModal(true);
  };

  const [showNotesModal, setShowNotesModal] = useState(false);
  const [noteText, setNoteText] = useState("");
  const [isImportant, setIsImportant] = useState(false);
  const [isEmergency, setIsEmergency] = useState(false);
  const [showFollowUpForm, setShowFollowUpForm] = useState(false);
  const [activeKey, setActiveKey] = useState("Prescriptions");
  const [showReminderModal, setShowReminderModal] = useState(false);
  const [reminderDate, setReminderDate] = useState("");
  const [reminderTime, setReminderTime] = useState("");
  const [openPrescriptions, setOpenPrescriptions] = useState({});
  const [prescriptionExplained, setPrescriptionExplained] = useState({});
  const [medicineStarted, setMedicineStarted] = useState({});
  const [openPrescription, setOpenPrescription] = useState(null);
  const [showFollowUpModal, setShowFollowUpModal] = useState(false);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [hovered, setHovered] = useState(null);
  const [isPersonalModalOpen, setIsPersonalModalOpen] = useState(false);
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [isDiseaseModalOpen, setIsDiseaseModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [isFileInputDisabled, setIsFileInputDisabled] = useState(false);
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");
  const [bmi, setBmi] = useState("");
  const [systolicBP, setSystolicBP] = useState("");
  const [diastolicBP, setDiastolicBP] = useState("");
  const [pulseRate, setPulseRate] = useState("");
  const [temperature, setTemperature] = useState("");
  const [oxygenSaturation, setOxygenSaturation] = useState("");
  const [bloodGlucose, setBloodGlucose] = useState("");
  const [allergies, setAllergies] = useState("");
  const [reports, setReports] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isPersonalInfoModalOpen, setIsPersonalInfoModalOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [noteDescription, setNoteDescription] = useState("");
  const [calendarEvents, setCalendarEvents] = useState(initialEvents);
  const [noteType, setNoteType] = useState("self");
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [activeNote, setActiveNote] = useState(null);
  const [showMessageBox, setShowMessageBox] = useState(false);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [showChart, setShowChart] = useState(false);
  const [selectedDiseaseId, setSelectedDiseaseId] = useState([])
  const [diseaseScripts, setDiseaseScripts] = useState([])
  const diseases = useSelector((state) => state.diseases?.diseases || [])
  const [loadingScripts, setLoadingScripts] = useState(false)
  const [loading, setLoading] = useState(false);
  const [panchkarmaBenefits, setPanchkarmaBenefits] = useState(false);

  const doctorIdFromUpcomingVisit =
    patientDetails?.upcomingVisits?.doctor_id || "";

  const [medicineDetails, setMedicineDetails] = useState({
    medicineName: "",
    medicineDose: "",
    frequency: "",
    weightOfDose: "",
    timePerDay: "",
    rateOfMedicine: "",
    anupaan: "",
  });

  const [lastNotes, setLastNotes] = useState("");
  const [selectedDiseases, setSelectedDiseases] = useState([]);
  const [prescriptions, setPrescriptions] = useState([]);
  const [followupList, setFollowupList] = useState([
    {
      prescriptionName: "Prescription ",
      date: "2025-06-28",
      time: "10:30",
      status: "Scheduled",
    },
    {
      prescriptionName: "Prescription ",
      date: "2025-06-30",
      time: "11:15",
      status: "Scheduled",
    },
  ]);

  // Initialize formData with default values
  const [formData, setFormData] = useState({
    patient_id: "",
    surname: "",
    firstName: "",
    husbandOrFatherName: "",
    dob1: "",
    age: "",
    whatsappNumber1: "",
    diseases: [],
    name: "",
    name1: "",
    Contact: "",
    email: "",
    profileImage: defaultAvatar,
    branch: "",
    additionalContact: "",
    dob: "",
    height: "",
    weight: "",
    occupation: "",
    married: false,
    spouseName: "",
    idProof: "",
    idNumber: "",
    deliveryOption: "",
    tempAddressLine1: "",
    tempAddressLine2: "",
    tempArea: "",
    tempCity: "",
    tempState: "",
    tempPincode: "",
    addressLine1: "",
    addressLine2: "",
    area: "",
    city: "",
    state: "",
    pincode: "",
    country: "",
    marriageHistory: "",
    marriageDate: "",
    currentDisease: [],
    diseaseStatus: "",
    spouseName1: "",
    spouseOption: "",
    profileImage1: defaultAvatar,
    gender: "",
    dateOfBirth: "",
    deliveryDate: "",
    panchkarmaTaken: false,
    reviewProvided: false,  // New field for Google Review
    testimonialProvided: false,  // New field for Testimonial
  });

  // Fetch patient details on component mount
  useEffect(() => {
    if (patientId) {
      dispatch(getPatientDetailsAction(patientId));
    }
  }, [dispatch, patientId]);

  // 🔹 Existing useEffect (already in your file)
  useEffect(() => {
    if (patientId) {
      dispatch(getPatientDetailsAction(patientId));
    }
  }, [dispatch, patientId]);

// Also ensure patientDetails has the ID
const actualPatientId = patientId || patientDetails?.patient_id;
  // 🔹 Add this new useEffect just below it
  useEffect(() => {
    const handleRefreshAfterBooking = () => {
      console.log("🔁 Refreshing patient details after new booking...");
      if (patientId) {
        dispatch(getPatientDetailsAction(patientId));
      }
    };

    console.log("👂 Listening for appointmentBooked...");
    window.addEventListener("appointmentBooked", handleRefreshAfterBooking);

    return () => {
      console.log("🧹 Removing appointmentBooked listener");
      window.removeEventListener("appointmentBooked", handleRefreshAfterBooking);
    };
  }, [dispatch, patientId]);

  useEffect(() => {
    dispatch(getDiseasesAction(false));
  }, [dispatch]);


  // Update formData when patientDetails changes
  useEffect(() => {
    if (patientDetails) {
      const marriageInfo = patientDetails.marriageInfo?.[0] || {};
      const tempAddress = patientDetails.TemporaryAddress || {};
      const permanentAddress = patientDetails.PermanentAddress || {};
      const currentDiseases = patientDetails.currentDiseases || {};
      const allDiseases = Array.isArray(patientDetails.diseases)
        ? patientDetails.diseases
        : [];
      // Calculate age from date of birth
      const calculateAge = (dob) => {
        if (!dob || dob === "0000-00-00") return "";
        const birthDate = new Date(dob);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        if (
          monthDiff < 0 ||
          (monthDiff === 0 && today.getDate() < birthDate.getDate())
        ) {
          age--;
        }
        return age.toString();
      };

      // ✅ FIXED — determine correct spouse info
      const spouseOption = (marriageInfo.spouse_option || "").toLowerCase().trim();
      let spouseName = marriageInfo.husband_or_spouse_name || "";

      // If spouse_option is "With Spouse" but name is missing, use first+last name
      if (spouseOption === "with spouse" && !spouseName) {
        spouseName = [
          marriageInfo.first_name,
          marriageInfo.middile_name,
          marriageInfo.last_name,
        ]
          .filter(Boolean)
          .join(" ")
          .trim();
      }

      // If still no name, fallback to "-"
      if (!spouseName) spouseName = "-";

      setFormData((prev) => ({
        ...prev,
        // Basic patient info
        firstName: patientDetails.first_name || "",
        surname: patientDetails.last_name || "",
        name: formatName(`${patientDetails.first_name || ""} ${patientDetails.middile_name || ""} ${patientDetails.last_name || ""}`.trim()),
        name1: formatName(`${patientDetails.first_name || ""} ${patientDetails.middile_name || ""} ${patientDetails.last_name || ""}`.trim()),

        email: patientDetails.patient_email || "",
        Contact: patientDetails.whatsapp_contact_no || "",
        additionalContact: patientDetails.additional_contact_no || "",
        gender: patientDetails.gender || "",
        dob: patientDetails.date_of_birth || "",
        dateOfBirth: patientDetails.date_of_birth || "",
        age: calculateAge(patientDetails.date_of_birth),
        height: patientDetails.height || "",
        weight: patientDetails.weight || "",
        occupation: patientDetails.occupation || "",
        idProof: patientDetails.id_proof || "",
        idNumber: patientDetails.id_number || "",
        profileImage1: getValidPhotoUrl(patientDetails.patient_photo),
        panchkarmaTaken: patientDetails.punchkarma_taken === "Yes",
        
        // ✅ NEW: Bind review and testimonial data from API
        reviewProvided: patientDetails.review_provided === "Yes",
        testimonialProvided: patientDetails.testimonial_provided === "Yes",

        // ✅ Marriage info (fixed)
        marriageDate: marriageInfo.date_of_marriage || "",
        marriageHistory: marriageInfo.marriage_history || "",
        spouseOption: spouseOption, // "with spouse" or "without spouse"
        spouseName1: spouseName, // full name fallback
        spouseName: spouseName,

        // Address info
        tempAddressLine1: tempAddress.address_line1 || "",
        tempAddressLine2: tempAddress.address_line2 || "",
        tempArea: tempAddress.area || "",
        tempCity: tempAddress.city || "",
        tempState: tempAddress.state || "",
        tempPincode: tempAddress.pincode || "",

        addressLine1: permanentAddress.address_line1 || "",
        addressLine2: permanentAddress.address_line2 || "",
        area: permanentAddress.area || "",
        city: permanentAddress.city || "",
        state: permanentAddress.state || "",
        pincode: permanentAddress.pincode || "",
        country: permanentAddress.country || "",

        // Disease info
        currentDisease: currentDiseases.disease_name
          ? [currentDiseases.disease_name]
          : [],
        diseases: allDiseases.map((d) => d.disease_name),
        diseaseStatus: currentDiseases.disease_status || ""
      }));

      // Set weight and height for BMI calculation
      setWeight(patientDetails.weight || "");
      setHeight(patientDetails.height || "");
    }
  }, [patientDetails]);

  const getValidPhotoUrl = (photoUrl) => {
    if (!photoUrl) return defaultAvatar; // use the imported default

    // If multiple "https://" exist, keep only the last valid part
    if ((photoUrl.match(/https:\/\//g) || []).length > 1) {
      const parts = photoUrl.split("https://");
      return "https://" + parts[parts.length - 1];
    }

    return photoUrl;
  };
  // Format date function
  // const formatDate = (dateString) => {
  //   if (!dateString) return "-";
  //   const date = new Date(dateString);
  //   return date.toLocaleDateString("en-US", {
  //     year: "numeric",
  //     month: "short",
  //     day: "numeric",
  //   });
  // };

  // Rest of your existing functions remain the same...
  const handleMarkAsDone = (index) => {
    Swal.fire({
      title: "Mark as Done?",
      text: "This follow-up will be marked as completed.",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, mark as done",
    }).then((result) => {
      if (result.isConfirmed) {
        const updated = [...followupList];
        updated[index].status = "Completed";
        setFollowupList(updated);
        Swal.fire(
          "Marked!",
          "The follow-up has been marked as completed.",
          "success"
        );
      }
    });
  };

  const handleCancel = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This follow-up reminder will be canceled.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, cancel it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedList = [...followupList];
        updatedList.splice(index, 1);
        setFollowupList(updatedList);
        Swal.fire(
          "Canceled!",
          "The follow-up reminder has been canceled.",
          "success"
        );
      }
    });
  };

  const handleEditProfileClick = () => {
    setIsProfileModalOpen(true);
  };

  const handleChange = (event) => {
    const { name, type, checked, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const weightData = [49, 55, 57, 65, 66, 78, 82];

  const handleShowChart = () => {
    setShowChart(true);
  };

  const handleCloseChart = () => {
    setShowChart(false);
  };

  const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);
  const [selectedPrescription, setSelectedPrescription] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);

  const prescriptionData = [
    {
      prescribedBy: "Dr. John Doe",
      date: "Jan 12, 2025",
      diseases: "Blood Test, Fever",
      status: "Pending",
    },
    {
      prescribedBy: "Dr. John Doe",
      date: "Jan 13, 2025",
      diseases: "Blood Test",
      status: "Delivered",
    },
    {
      prescribedBy: "Dr. John Doe",
      date: "Jan 1, 2025",
      diseases: "Blood Test, Fever",
      status: "Pending",
    },
    {
      prescribedBy: "Dr. John Doe",
      date: "Jan 13, 2025",
      diseases: "Blood Test",
      status: "Delivered",
    },
    {
      prescribedBy: "Dr. John Doe",
      date: "Jan 1, 2025",
      diseases: "Blood Test, Fever",
      status: "Pending",
    },
    {
      prescribedBy: "Dr. John Doe",
      date: "Jan 13, 2025",
      diseases: "Blood Test",
      status: "Delivered",
    },
    {
      prescribedBy: "Dr. John Doe",
      date: "Jan 1, 2025",
      diseases: "Blood Test, Fever",
      status: "Pending",
    },
  ];

  const handleViewClick = (prescription) => {
    setSelectedPrescription(prescription);
    setShowDetailModal(true);
  };

  const [modifiedPrescriptions, setModifiedPrescriptions] = useState([
    {
      medicineName: "Eladi Gaan kadha",
      dose: "1",
      frequency: "BD - Morning (5am to 9am) - Evening (4pm to 7pm)",
      quantity: "3",
      deliveredQuantity: "2",
      howToTake:
        "Boil half a teaspoon of the medicine + 2 cups of water together, save half a cup of water, then strain and drink.",
    },
    // ... rest of your prescription data
  ]);

  const appointments = [
    {
      date: "07/04/2025",
      notes: [
        {
          title: "Questionnaire",
          content: [
            {
              question: "How are you feeling since your last visit?",
              answer: "Some symptoms have improved, but fatigue remains.",
            },
            // ... rest of questionnaire data
          ].map((qa, index) => (
            <div key={index} className="mb-2">
              <strong>
                Q{index + 1}: {qa.question}
              </strong>
              <p>A: {qa.answer}</p>
            </div>
          )),
        },
        // ... rest of notes
      ],
    },
    // ... rest of appointments
  ];

  const [filteredAppointments, setFilteredAppointments] = useState([
    ...appointments,
  ]);
  const [activeFilter, setActiveFilter] = useState("All");
  const [sortDirection, setSortDirection] = useState("desc");

  const followupCallCount = appointments.filter((app) =>
    app.notes.some((note) => note.title.includes("Service Caller"))
  ).length;

  const prescription = 5;
  const questions = 3;

  const [data, setData] = useState({});
  const [doctorNoteCount, setDoctorNoteCount] = useState(0);
  const [telecallerNoteCount, setTelecallerNoteCount] = useState(0);

  // Rest of your useEffect and other functions remain the same...
  useEffect(() => {
    let filtered = [...appointments];
    if (activeFilter !== "All") {
      filtered = appointments.filter((appointment) => {
        return appointment.notes.some((note) => {
          const titleLower = note.title.toLowerCase();
          switch (activeFilter.toLowerCase()) {
            case "reports":
              return titleLower.includes("report");
            case "notes":
              return (
                titleLower === "notes" ||
                titleLower === "note" ||
                titleLower.includes("doctor note") ||
                titleLower.includes("telecaller note")
              );
            case "panchkarma":
              return titleLower.includes("panchakarma");
            case "counsellor":
              return titleLower.includes("counsellor");
            case "medical":
              return titleLower.includes("medical");
            default:
              return false;
          }
        });
      });

      filtered = filtered.map((appointment) => {
        const filteredAppointment = { ...appointment };
        filteredAppointment.notes = appointment.notes.filter((note) => {
          const titleLower = note.title.toLowerCase();
          switch (activeFilter.toLowerCase()) {
            case "reports":
              return titleLower.includes("report");
            case "notes":
              return (
                titleLower === "notes" ||
                titleLower === "note" ||
                titleLower.includes("doctor note") ||
                titleLower.includes("telecaller note")
              );
            case "panchkarma":
              return titleLower.includes("panchakarma");
            case "counsellor":
              return titleLower.includes("counsellor");
            case "medical":
              return titleLower.includes("medical");
            default:
              return false;
          }
        });
        return filteredAppointment;
      });
    }

    filtered.sort((a, b) => {
      const dateA = new Date(a.date.split("/").reverse().join("-"));
      const dateB = new Date(b.date.split("/").reverse().join("-"));
      return sortDirection === "asc" ? dateA - dateB : dateB - dateA;
    });

    setFilteredAppointments(filtered);
  }, [activeFilter, sortDirection]);

  const handleFilterChange = (filter) => {
    setActiveFilter(filter);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newPrescription, setNewPrescription] = useState({
    medicineName: "",
    dose: "",
    frequency: "",
    quantity: "",
    howToTake: "",
  });

  // All your other existing functions remain the same...
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewPrescription({ ...newPrescription, [name]: value });
  };

  const handleInputonChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleOnSubmit = () => {
    setPrescriptions([...prescriptions, newPrescription]);
    setNewPrescription({
      medicineName: "",
      dose: "",
      frequency: "",
      quantity: "",
      howToTake: "",
    });
    setIsModalOpen(false);
  };

  const handleGeneratePrescription = () => {
    ("Prescription generated!");
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleGenderChange = (selectedOption) => {
    setFormData({ ...formData, gender: selectedOption.value });
  };

  const handleMarriageHistoryChange = (selectedOption) => {
    setFormData({ ...formData, marriageHistory: selectedOption.value });
  };

  const handleCurrentDiseaseChange = (selectedOption) => {
    setFormData({ ...formData, currentDisease: selectedOption.value });
  };

  const handleStatusChange = (selectedOption) => {
    setFormData({ ...formData, diseaseStatus: selectedOption.value });
  };

  const handleSpouseOptionChange = (e) => {
    setFormData({ ...formData, spouseOption: e.target.value });
  };

  const handleINChange = (group, index, value) => {
    setData((prevData) => {
      const updatedData = { ...prevData };
      updatedData[group][index] = value;
      return updatedData;
    });
  };

  const handleSave = (e) => {
    e.preventDefault();
    console.log({
      patientName,
      medicineDetails,
      lastNotes,
      selectedDiseases: selectedDiseases.map((option) => option.value),
    });
  };

  const diseaseOptions = [
    { value: "diabetes", label: "Diabetes" },
    { value: "sleepProblem", label: "Sleep Problem" },
    { value: "dentalCare", label: "Dental Care" },
    { value: "hypertension", label: "Hypertension" },
  ];

  const handleSubmitDiseases = (e) => {
    e.preventDefault();
    console.log("Diseases Data:", formData.diseases);
    setIsDiseaseModalOpen(false);
  };

  const handleEditDiseaseClick = () => {
    setIsDiseaseModalOpen(true);
  };

  const calculateBMI = (w, h) => {
    if (w > 0 && h > 0) {
      setBmi((w / (h * h)) * 10000);
    } else {
      setBmi("");
    }
  };

  const handleWeightChange = (e) => {
    const w = e.target.value;
    setWeight(w);
    calculateBMI(w, height);
  };

  const handleHeightChange = (e) => {
    const h = e.target.value;
    setHeight(h);
    calculateBMI(weight, h);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log({
      systolicBP,
      diastolicBP,
      weight,
      height,
      bmi,
      pulseRate,
      temperature,
      oxygenSaturation,
      bloodGlucose,
      allergies,
      reports,
    });
  };

  const openModal = () => setIsModalVisible(true);
  const closeModal = () => setIsModalVisible(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => {
    setShowModal(false);
    setNoteDescription("");
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    setUploadedFiles((prevFiles) => [...prevFiles, ...files]);
  };

  const handleView = (file) => {
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, "_blank");
  };

  const handleDelete = (index) => {
    setUploadedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const roleOptions = [
    { value: "counselor", label: "Counselor" },
    { value: "medical", label: "Medical" },
  ];

  const handleInChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleinSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };

  const handleAddNote = () => {
    const newNote = {
      description: noteDescription,
      type: noteType,
      roles: selectedRoles.map((role) => role.value),
    };
    console.log("Note Type:", noteType);
    console.log("Selected Roles:", selectedRoles);
    console.log("New Note:", newNote);
    setNoteDescription("");
    setNoteType("self");
    setSelectedRoles([]);
    handleClose();
  };

  const handleDeliveryOptionChange = (selectedOption) => {
    setFormData({ ...formData, deliveryOption: selectedOption.value });
  };

  const handleComplete = (index) => {
    const updated = [...followupList];
    updated[index].status = "Completed";
    setFollowupList(updated);
    Swal.fire({
      title: "Completed!",
      text: "Task has been marked as complete.",
      icon: "success",
      confirmButtonText: "Done",
      confirmButtonColor: "#198754",
    });
  };

  const targetDate = "08/04/2025";
  const appointmentsOnDate = filteredAppointments.filter(
    (appointment) => appointment.date === targetDate
  );

  const togglePrescription = (index, noteIndex) => {
    const key = `${index}-${noteIndex}`;
    setOpenPrescriptions((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  useEffect(() => {
    if (selectedDiseaseId.length === 0) return;  // don't auto-fire

    (async () => {
      try {
        const res = await getDiseaseWiseScript(selectedDiseaseId);
        if (res.data.status === "success") {
          setDiseaseScripts(res.data.data || []);
        } else {
          setDiseaseScripts([]);
        }
      } catch (error) {
        console.error("Error fetching scripts:", error);
        setDiseaseScripts([]);
      }
    })();
  }, [selectedDiseaseId]);


  useEffect(() => {
    if (!patientDetails?.diseases?.length) return;

    const autoSelected = patientDetails.diseases.map(d => ({
      value: String(d.disease_id),
      label: d.disease_name
    }));

    const ids = autoSelected.map(d => d.value);

    // Set dropdown values
    setSelectedDiseases(autoSelected);
    setSelectedDiseaseId(ids);

  }, [patientDetails]);


  const handleDiseaseChange = async (selectedOptions) => {
    setSelectedDiseases(selectedOptions || []);
    const ids = (selectedOptions || []).map((option) => String(option.value));
    setSelectedDiseaseId(ids);

    setLoadingScripts(true);

    try {
      const res = await getDiseaseWiseScript(ids);
      if (res.data.status === "success") {
        const nonEmptyScripts = res.data.data.filter(d => d.scripts?.length > 0);
        setDiseaseScripts(nonEmptyScripts);
      } else {
        setDiseaseScripts([]);
      }
    } catch (error) {
      console.error("Failed to fetch disease scripts:", error);
      setDiseaseScripts([]);
    } finally {
      setLoadingScripts(false);
    }
  };

  const handleSendReport = async () => {
    try {
      const payload = {
        patient_id: patientId || null,
  
        send_to: patientId
          ? "PATIENT"
          : selectedRecipient?.toUpperCase(),
  
        // other fields if required
        // report_id
        // whatsapp_no
      };
  
      await dispatch(sendReportLinkAction(payload));
    } catch (error) {
      console.error("Send report failed", error);
    }
  };
  const handleSaveReminder = () => {
    console.log("Save reminder called with:", { reminderDate, reminderTime });
    if (!reminderDate || !reminderTime) {
      Swal.fire({
        title: "Missing Information",
        text: "Please select both date and time for the reminder.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    const selectedDateTime = new Date(`${reminderDate}T${reminderTime}`);
    const now = new Date();
    if (selectedDateTime <= now) {
      Swal.fire({
        title: "Invalid Date/Time",
        text: "Please select a future date and time for the reminder.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    const newReminder = {
      prescriptionName: "Prescription Reminder",
      date: reminderDate,
      time: reminderTime,
      status: "Scheduled",
      createdAt: new Date().toISOString(),
    };

    setFollowupList((prev) => [...prev, newReminder]);
    console.log("Reminder saved successfully:", newReminder);

    setReminderDate("");
    setReminderTime("");
    setShowReminderModal(false);

    Swal.fire({
      title: "Success!",
      text: `Follow-up reminder has been scheduled for ${new Date(
        selectedDateTime
      ).toLocaleString()}.`,
      icon: "success",
      confirmButtonText: "OK",
    });
  };
  // ⭐ Testimonial API
  const handleTestimonialChange = async (e) => {
    const checked = e.target.checked;

    // update UI immediately
    setFormData((prev) => ({
      ...prev,
      testimonialProvided: checked,
    }));

    try {
      await axiosInstance.post("patient/testimonialProvided", {
        patient_id: patientId,
        testimonial_provided: checked ? "Yes" : "No",
      });

      Swal.fire("Success", "Testimonial updated", "success");
    } catch (error) {
      Swal.fire("Error", "Failed to update testimonial", "error");
    }
  };

  // ⭐ Google Review API
  const handleGoogleReviewChange = async (e) => {
    const checked = e.target.checked;

    setFormData((prev) => ({
      ...prev,
      reviewProvided: checked,
    }));

    try {
      await axiosInstance.post("patient/reviewProvided", {
        patient_id: patientId,
        review_provided: checked ? "Yes" : "No",
      });

      Swal.fire("Success", "Google review updated", "success");
    } catch (error) {
      Swal.fire("Error", "Failed to update review", "error");
    }
  };
  const handleOpen = (patientId) => {
    if (!patientId) return;

    // Optional: store any patient data if needed
    // sessionStorage.setItem("casePaperPatientData", JSON.stringify(patientData));

    // Open case-paper page in a new tab
    window.open(`/case-paper/${patientId}`, "_blank", "noopener,noreferrer");
  };

  const tabStyle = (key) => ({
    backgroundColor: activeKey === key ? "#005f66" : "transparent",
    color: activeKey === key ? "#ffffff" : "#005f66",
    borderRadius: "6px",
    transition: "all 0.2s ease-in-out",
    padding: "10px 18px",
    fontSize: "16px",
    fontWeight: "600",
    fontSize: "20px"

  });
  const handleSaveNote = () => {
    console.log("Note:", noteText);
    console.log("Important:", isImportant);
    console.log("Emergency:", isEmergency);
    setShowNotesModal(false);
  };


  return (
    <>
      <div className="d-flex justify-content-end mb-4">
        <Button variant="primary" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>

      <div className="row">
        <div className="col-lg-6 col-12 mb-4">
          <div className="card">
            <div className="card-body pt-4">
              {/* <div className="media d-sm-flex d-block text-center text-sm-start pb-4 mb-4 border-bottom"> */}
              <div className="media d-flex flex-column flex-sm-row text-center text-sm-start pb-4 mb-4 border-bottom">
                <img
                  alt=""
                  className="rounded me-sm-4 me-0"
                  width={100}
                  src={formData.profileImage1 || "/placeholder.svg"}
                />
                <div className="media-body w-100">

                  {/* NAME + UPLOAD + ICON */}
                  <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center w-100">

                    <h3 className="fs-22 text-black font-w600 mb-2 mb-sm-0">
                      {formData.name1}
                    </h3>
                    {/* </div> */}
                    <span className="d-flex align-items-center mt-2 mt-sm-0">
                    <img
  src={sendreport || "/placeholder.svg"}
  alt="Send Report"
  onClick={handleSendReport}
  style={{
    cursor: "pointer",
    width: "32px",
    height: "32px",
    marginRight: "15px",
  }}
  title="Send Report"
/>
                      <div className="me-3">
                        <UploadReportButton patientId={patientId}  />
                      </div>
                      <button
                        className="btn d-flex align-items-center justify-content-center me-3"
                        onClick={() =>
                          openEmergencyPopup({
                            id: patientDetails?.patient_id || patientDetails?.id,
                            name: formData.name1,
                            gender: formData.gender,
                            phone: formData.Contact || "",
                            disease: formData.currentDisease?.[0] || "-",
                            status: formData.diseaseStatus || "-"
                          })
                        }
                        title="Mark as Emergency"
                        style={{ width: "32px", height: "32px", padding: "0" }}
                      >
                        <img
                          src={emergencyIcon}
                          alt="Emergency"
                          style={{ width: "30px", height: "30px" }}
                        />
                      </button>

                      <img
                        src={icon3 || "/placeholder.svg"}
                        alt="Case Paper"
                        onClick={() =>
                          handleOpen(patientDetails?.patient_id || patientDetails?.id)
                        }
                        style={{ cursor: "pointer", width: "28px", height: "28px" }}
                        title="Open case-paper"
                      />

                    </span>
                  </div>
                  <div className="d-flex flex-wrap align-items-center gap-3 mt-3">
                    <Link
                      to="#"
                      className="btn bgl-primary btn-rounded text-black me-2"
                      title={formData.gender ? `${formData.gender}` : "No gender selected"}
                    >
                      {formData.gender === "Male" && (
                        <>
                          <svg
                            className="me-2 scale5"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14 2H22V10H20V5.41L15.71 9.71C16.45 10.79 16.91 12.1 16.98 13.5C17.17 17.14 14.32 20.24 10.68 20.48C6.79 20.74 3.5 17.6 3.5 13.71C3.5 9.82 6.65 6.53 10.54 6.29C11.94 6.2 13.25 6.66 14.34 7.41L18.59 3H14V2Z"
                              fill="#2BC155"
                            />
                          </svg>
                          M
                        </>
                      )}
                      {formData.gender === "Female" && (
                        <>
                          <svg
                            className="me-2 scale5"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 2C8.13 2 5 5.13 5 9C5 12.52 7.61 15.44 11 15.93V18H8V20H11V22H13V20H16V18H13V15.93C16.39 15.44 19 12.52 19 9C19 5.13 15.87 2 12 2ZM12 13C9.24 13 7 10.76 7 8C7 5.24 9.24 3 12 3C14.76 3 17 5.24 17 8C17 10.76 14.76 13 12 13Z"
                              fill="#C92A2A"
                            />
                          </svg>
                          F
                        </>
                      )}
                      {formData.gender === "Transgender" && (
                        <>
                          <svg
                            className="me-2 scale5"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M19 3h-2.59l1.3 1.29-2.83 2.83c-.85-.54-1.84-.87-2.88-.98V4h1V2h-4v2h1v2.14c-2.79.47-5 2.93-5 5.86 0 3.31 2.69 6 6 6 .57 0 1.11-.08 1.63-.24l1.63 1.63V20h-2v2h4v-2h-1v-1.17l-1.41-1.41c1.48-.98 2.46-2.65 2.46-4.59 0-1.04-.29-2.02-.78-2.85l2.83-2.83L21 6.59V4h-2V3zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
                              fill="#C92A2A"
                            />
                          </svg>
                          Trans
                        </>
                      )}
                      {!formData.gender && <span> - </span>}
                    </Link>
                    <div className="form-check d-flex align-items-center m-0">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="panchkarmaTaken"
                        checked={formData.panchkarmaTaken}
                        onChange={async (e) => {
                          const checked = e.target.checked;

                          setFormData({ ...formData, panchkarmaTaken: checked });

                          if (!patientId) return;

                          setLoading(true);
                          await dispatch(
                            updatePanchkarmaTakenAction({
                              patient_id: patientId,
                              panchkarmaTaken: checked,
                            })
                          );
                          setLoading(false);
                        }}
                        disabled={loading}
                        style={{ cursor: "pointer" }}
                      />
                      <label
                        className="form-check-label ms-2"
                        htmlFor="panchkarmaTaken"
                        style={{ cursor: "pointer", whiteSpace: "nowrap", fontSize: "16px" }}
                      >
                        Panchkarma Taken
                      </label>
                    </div>

                    {/* Google Review Provided */}
                    <div className="form-check d-flex align-items-center m-0">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="googleReview"
                        checked={formData.reviewProvided || false}
                        onChange={handleGoogleReviewChange}
                        style={{ cursor: "pointer" }}
                      />
                      <label
                        className="form-check-label ms-2"
                        htmlFor="googleReview"
                        style={{ cursor: "pointer", whiteSpace: "nowrap", fontSize: "16px" }}
                      >
                        Google Review
                      </label>
                    </div>

                    {/* Testimonial Provided */}
                    <div className="form-check d-flex align-items-center m-0">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="testimonialGiven"
                        checked={formData.testimonialProvided || false}
                        onChange={handleTestimonialChange}
                        style={{ cursor: "pointer" }}
                      />
                      <label
                        className="form-check-label ms-2"
                        htmlFor="testimonialGiven"
                        style={{ cursor: "pointer", whiteSpace: "nowrap", fontSize: "16px" }}
                      >
                        Testimonial
                      </label>
                    </div>

                  </div>
                </div>
              </div>

              <div className="row">
                <div className="row mb-2">
                  <div className="col-4">
                    <h5 className="f-w-500">Husband / Wife Name:</h5>
                    <span>{formData.spouseName1 || "-"}</span>
                  </div>
                  <div className="col-4">
                    <h5 className="f-w-500">Age:</h5>
                    <span>{formData.age}</span>
                  </div>
                  <div className="col-4">
                    <h5 className="f-w-500" style={{ whiteSpace: "nowrap" }}>
                      Occupation:
                    </h5>

                    <span>{formData.occupation || "-"}</span>
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="col-4">
                    <h5 className="f-w-500">Weight: (kg)</h5>
                    <span>{formData.weight || "-"} </span>
                    <img
                      src={icon || "/placeholder.svg"}
                      alt="History Icon"
                      onClick={handleShowChart}
                      title=" View Weight History"
                      style={{
                        cursor: "pointer",
                        marginLeft: "8px",
                        width: "24px",
                        height: "24px",
                      }}
                    />
                  </div>

                  {/* Weight Chart Component */}
                  <WeightChart
                    patientId={patientId}
                    show={showChart}
                    onClose={handleCloseChart}
                    height={formData.height}
                    gender={formData.gender}
                  />

                  <div className="col-4">
                    <h5 className="f-w-500">Marriage History:</h5>
                    <span>{formData.marriageHistory || "-"}</span>
                  </div>
                  <div className="col-4">
                    <h5 className="f-w-500">Marriage Date:</h5>
                    <span>
                      {formData.marriageDate ? formatDate(formData.marriageDate) : "-"}
                    </span>
                  </div>

                </div>

                <div className="row mb-2">
                  <div className="col-4">
                    <h5 className="f-w-500">Current Disease:</h5>
                    <span>{formData.currentDisease.join(", ") || "-"}</span>
                  </div>
                  <div className="col-4">
                    <h5 className="f-w-500">Status:</h5>
                    <span>{formData.diseaseStatus || "-"}</span>
                  </div>
                  <div className="col-4">
                    <h5 className="f-w-500">With Spouse:</h5>
                    {/* <span>
                      {formData.spouseOption === "withSpouse" ? "Yes" : "No"}
                    </span> */}
                    <span>
                      {!formData.spouseOption
                        ? "-" // no response
                        : formData.spouseOption.toLowerCase() === "with spouse" ||
                          formData.spouseOption.toLowerCase() === "withspouse"
                          ? "Yes"
                          : "No"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-6 col-12 mb-4">
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h4 className="fs-22 text-black font-w600 mb-0">Diseases</h4>
              </div>

              <div className="d-flex flex-row justify-content-start align-items-center mb-4">
                {formData.diseases.map((disease, index) => (
                  <div key={index} className="media me-4">
                    <div className="media-body">
                      <h5 className="mt-0 vertical-text bg-primary rounded-pill px-3 py-2 text-white">
                        {disease}
                      </h5>
                    </div>
                  </div>
                ))}
              </div>

              {/* Upcoming Visits Card */}
              <div className="mb-4">
                <h5 className="fs-18 font-w600 mb-3">Upcoming Visits:</h5>
                {patientDetails?.upcomingVisits ? (
                  <div className="d-flex align-items-center">
                    <div>
                      <h6 className="mb-1 text-muted">
                        <strong>Date:</strong>{" "}
                        {formatDate(patientDetails.upcomingVisits.date)}
                      </h6>
                      <p className="mb-0 text-muted">
                        <strong>Doctor:</strong>{" "}
                        {patientDetails.upcomingVisits.doctor_name}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="ps-1">
                    <p className="mb-0 text-muted">
                      No upcoming visits scheduled
                    </p>
                  </div>
                )}
              </div>

              <div>
                <h5 className="fs-18 font-w600 mb-3">Last Visit:</h5>
                {patientDetails?.lastVisit ? (
                  <div className="d-flex align-items-center">
                    <div>
                      <h6 className="mb-1 text-muted">
                        <strong>Date:</strong>{" "}
                        {formatDate(patientDetails.lastVisit.date)}
                      </h6>
                      <p className="mb-0 text-muted">
                        <strong>Doctor:</strong>{" "}
                        {patientDetails.lastVisit.doctor_name}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="ps-1">
                    <p className="mb-0 text-muted">No previous visits found</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid" style={{ padding: "20px" }}>
          <div className="row">
            <div className="col-xl-12">
              <div className="card" style={{ width: "100%" }}>
                <div className="card-body ">
                  <div className="profile-tab">
                    <div className="custom-tab-1">
                      <Tab.Container
                        activeKey={activeKey}
                        onSelect={(k) => setActiveKey(k)}
                      >
                        <Nav
                          as="ul"
                          className="nav nav-tabs flex-wrap"
                          style={{ whiteSpace: "normal" }}
                          activeKey={activeKey}
                          onSelect={(k) => setActiveKey(k)} // make sure you have a state for activeKey
                        >
                          {["Prescriptions", "Followup-Remider", "Diseases", "Notes", "Appointments"].map((key) => (
                            <Nav.Item as="li" className="nav-item" key={key}>
                              <Nav.Link eventKey={key} style={tabStyle(key)}>
                                {key === "Followup-Remider" ? "Follow-Up Reminder" : key === "Diseases" ? "Diseases History" : key === "Appointments" ? "Appointment" : key === "Script" ? "Script" : key}
                              </Nav.Link>
                            </Nav.Item>
                          ))}

                          {formData.gender === "Female" && (
                            <>
                              <Nav.Item as="li" className="nav-item">
                                <Nav.Link eventKey="Menopause" style={tabStyle("Menopause")}>
                                  LMP
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item as="li" className="nav-item">
                                <Nav.Link eventKey="GAPLD" style={tabStyle("GAPLD")}>
                                  GPLDA
                                </Nav.Link>
                              </Nav.Item>
                            </>
                          )}
                          <Nav.Item as="li" className="nav-item">
                            <Nav.Link
                              eventKey="Script"
                              style={tabStyle("Script")}
                            >
                              Script
                            </Nav.Link>
                          </Nav.Item>

                          <Nav.Item as="li" className="nav-item">
                            <Nav.Link
                              eventKey="noteshistory"
                              style={tabStyle("noteshistory")}
                            >
                              Summary
                            </Nav.Link>
                          </Nav.Item>

                          {formData.gender === "Male" && (
                            <>
                              <Nav.Item as="li" className="nav-item">
                                <Nav.Link eventKey="Malechart" style={tabStyle("Malechart")}>
                                  Male Chart
                                </Nav.Link>
                              </Nav.Item>

                              <Nav.Item as="li" className="nav-item">
                                <Nav.Link eventKey="GAPLD" style={tabStyle("GAPLD")}>
                                  GPLDA
                                </Nav.Link>
                              </Nav.Item>
                            </>
                          )}

                        </Nav>

                        <Tab.Content>
                          <Tab.Pane eventKey="GAPLD">
                            <PatientGapld />
                          </Tab.Pane>
                          <Tab.Pane eventKey="Menopause">
                            <MenopauseChart></MenopauseChart>
                          </Tab.Pane>
                          <Tab.Pane eventKey="Malechart">
                            <PatientMale></PatientMale>
                          </Tab.Pane>
                          <Tab.Pane eventKey="Followups">
                            <ServiceCallerFollowup />
                          </Tab.Pane>
                          <Tab.Pane eventKey="Followup-Remider">
                            <ServiceCallerFollowupReminder />
                          </Tab.Pane>
                          <Tab.Pane eventKey="Diseases">
                            <DiseaseHistory patientId={patientId} />
                          </Tab.Pane>
                          <Tab.Pane eventKey="noteshistory">
                            <NotesHistory></NotesHistory>
                          </Tab.Pane>
                          <Tab.Pane eventKey="Prescriptions">
                            <Prescription
                              patientId={patientId}
                              patientName={patientName}
                              patientGender={patientGender}
                              setActiveKey={setActiveKey}
                            />
                          </Tab.Pane>
                          <Tab.Pane eventKey="Notes">
                            <ServiceCallerNotes
                              defaultDoctorId={"1"}
                              patientId={patientId}
                            />
                          </Tab.Pane>
                          <Tab.Pane eventKey="Appointments">
                            <ServiceCallerAppointmentCalendar
                                patientId={actualPatientId || patientId}
                              leadId={undefined} // Using patientId as leadId since this is a converted patient
                              doctorId={doctorIdFromUpcomingVisit} // Will be selected in the calendar component
                            />
                          </Tab.Pane>
                          <Tab.Pane eventKey="Script">
                            {diseases?.length > 0 ? (
                              <>
                                <div className="mb-4 pt-4 px-3 pb-3 ">
                                  <h5 className="mb-2">Select Disease(s) to View Script</h5>
                                  <Select
                                    isMulti
                                    options={diseases.map((d) => ({
                                      value: String(d.disease_id),
                                      label: d.disease_name,
                                    }))}
                                    value={diseases
                                      .filter((d) => selectedDiseaseId.includes(String(d.disease_id)))
                                      .map((d) => ({
                                        value: String(d.disease_id),
                                        label: d.disease_name,
                                      }))
                                    }
                                    onChange={handleDiseaseChange}
                                    placeholder="Choose disease(s)..."
                                    classNamePrefix="select"
                                    styles={{
                                      control: (base, state) => ({
                                        ...base,
                                        minHeight: "50px",
                                        fontSize: "14px",
                                        borderRadius: "0.5rem",
                                        borderColor: state.isFocused ? "#007bff" : "#ced4da",
                                        boxShadow: state.isFocused
                                          ? "0 0 0 0.2rem rgba(0,123,255,.25)"
                                          : "none",
                                      }),
                                      menu: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                  />

                                  {/* ✅ NEW: Panchkarma Benefits Explained Checkbox */}
                                  <div className="form-check mt-3">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="panchkarmaBenefits"
                                      checked={panchkarmaBenefits}
                                      onChange={(e) => setPanchkarmaBenefits(e.target.checked)}
                                    />
                                    <label
                                      className="form-check-label fw-semibold"
                                      htmlFor="panchkarmaBenefits"
                                    >
                                      Panchkarma Benefits Explained
                                    </label>
                                  </div>
                                </div>

                                {loadingScripts ? (
                                  <div className="text-center my-4">
                                    <div className="spinner-border text-primary" role="status">
                                      <span className="visually-hidden">Loading...</span>
                                    </div>
                                  </div>
                                ) : diseaseScripts.length === 0 ? (
                                  <div className="text-muted mt-3">
                                    No scripts found for selected diseases.
                                  </div>
                                ) : (
                                  <div className="mt-3">
                                    {diseaseScripts.map((disease, index) => (
                                      <div key={index} className="mb-4">
                                        <h6 className="fw-bold">{disease.disease_name}</h6>
                                        {disease.scripts.map((script, i) => (
                                          <div
                                            key={i}
                                            className="mb-3"
                                            style={{
                                              backgroundColor: "#f8f9fa",
                                              padding: "15px",
                                              borderRadius: "10px",
                                              fontSize: "15px",
                                              color: "#212529",
                                              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                                            }}
                                          >
                                            <p className="mb-0">{script.script_text}</p>
                                          </div>
                                        ))}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </>
                            ) : (
                              <div className="text-muted">No diseases found.</div>
                            )}
                          </Tab.Pane>

                        </Tab.Content>
                      </Tab.Container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <EmergencyModal
        show={showEmergencyModal}
        onClose={() => setShowEmergencyModal(false)}
        patient={emergencyPatient}
      />

    </>
  );
};

export default ViewDetails;